export default __webpack_public_path__ + "static/media/donut-04.38c011e5.png";